const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const Immutable = require('immutable');

// @commons
const { OKLink } = require('commonsComponents/OKLink');

// @components
const BrokerMyInvestmentsWrappedContractsTable = require('../../brokerMyInvestmentsWrappedContractsTable/brokerMyInvestmentsWrappedContractsTable');
const BrokerMyInvestmentsFundsTable = require('components/broker/myInvestments/brokerMyInvestmentsFundsTable/brokerMyInvestmentsFundsTable');

// @helpers
const { formatText } = require('core/i18n').i18n;

// @constants
const {
    TYPE_FUNDS,
    EURO_TEXT,
    MYPROFILE_BROKER_EXPLORE_FUNDS_URL,
} = require('constants/index');

class brokerMyInvestmentsWrappedFundsContractTable extends React.Component {

    buildShowTableFunds(immProducts, type) {
        return (
            <BrokerMyInvestmentsFundsTable
                type={type}
                immStocks={immProducts}
                alternativeValueColumnTitle={false}
                isContractSection={true}
                immFundsContributionsList={this.props.immFundsContributionsList}
            />
        );
    }

    render() {
        const { immContract, immStocksByType, accountNumber, postWalletAlias, type, immBrokerContractState } = this.props;
        const earningsPercentage = immContract.get('profitablePercentage');
        const earnings = immContract.get('summarizedProfitability');
        const totalValue = immContract.get('summarizedValor');
        const capital = immContract.get('investmentsCapital');
        const contractNumber = immContract.getIn(['elements', '0', 'numerodecontrato']);
        const product = immContract.getIn(['elements', '0', 'producto']);
        const contractId = `${product}${contractNumber}`;
        const contractName = immContract.get('descripcion');
        const currency = EURO_TEXT; // @hardcoded
        const interventionType = immContract.getIn(['elements', '0', 'interventionType']);
        const contractForTooltip = immContract.getIn(['elements', '0', 'contractForTooltip']);

        const contract = Immutable.fromJS({
            numerodecontrato: contractNumber,
            producto: product
        });

        let immProducts = [];
        immProducts = immStocksByType.getIn(['funds', 'stocks']).filter(product => {
            return product.get('numerodecontrato') === contractNumber
        });

        if(immProducts.size === 0) {
            immProducts = immStocksByType.getIn(['alternativeFunds', 'stocks']).filter(product => {
                return product.get('numerodecontrato') === contractNumber
            });
        }

        const fundId = immProducts.getIn(['0', 'id']);

        const showTable = this.buildShowTableFunds(immProducts, TYPE_FUNDS);

        return (
            <BrokerMyInvestmentsWrappedContractsTable
                size={immProducts.size}
                contract={contract}
                contractName={contractName}
                accountNumber={accountNumber}
                immBrokerContractState={immBrokerContractState}
                currency={currency}
                earnings={earnings}
                earningsPercentage={earningsPercentage}
                capital={capital}
                total={totalValue}
                key={accountNumber}
                contractId={contractId}
                fundId={fundId}
                postAlias={postWalletAlias}
                interventionType={interventionType}
                contractForTooltip={contractForTooltip}
                onInternalTransferFundsClick={this.props.onInternalTransferFundsClick}
                setOrdersAndMovementsContract={this.props.setOrdersAndMovementsContract}
                type={type}
                pageName={this.props.pageName}
                immFundsContributionsList={this.props.immFundsContributionsList}
            >
                {showTable}
                <div className="broker-my-investments-tables__link-wrapper clearfix">
                    <div className="pull-left my-investments-tables__link">
                        <OKLink to={MYPROFILE_BROKER_EXPLORE_FUNDS_URL}>
                            {formatText(`broker-fundsLinkText`)}
                        </OKLink>
                    </div>
                </div>
            </BrokerMyInvestmentsWrappedContractsTable>
        );
    }
}

brokerMyInvestmentsWrappedFundsContractTable.propTypes = {
    immContract: PropTypes.object,
    immBrokerContractState: PropTypes.object,
    immStocksByType: PropTypes.object,
    accountNumber: PropTypes.number,
    type: PropTypes.string,
    postWalletAlias: PropTypes.func.isRequired,
    setOrdersAndMovementsContract: PropTypes.func.isRequired,
    onInternalTransferFundsClick: PropTypes.func.isRequired,
    pageName: PropTypes.func
};

module.exports = brokerMyInvestmentsWrappedFundsContractTable;
